/**
 * The microphone of a voice sample (ADR-0062): the browser's recorder with settings fit for a
 * voiceprint. Automatic gain control keeps quiet microphones audible; noise suppression and
 * echo cancellation stay off to preserve the voice. One channel, and twice the
 * questioning's bitrate: half a minute is small either way. The same recorder reads the true
 * level beside its meter, for the room check and the guidance on loudness.
 *
 * These are wishes: a browser that ignores one records all the same, and one that refuses them is
 * asked again with the questioning's settings (`openBrowserRecorder`). What a phone's browser
 * really honours was not measured.
 */
import { type BrowserRecorderOptions, openBrowserRecorder } from '../recording/browser-recorder'
import type { RecorderDevice } from '../recording/recorder-controller'

/** Mono with automatic gain, without noise suppression or echo cancellation. */
export const VOICE_SAMPLE_AUDIO: MediaTrackConstraints = {
  channelCount: 1,
  echoCancellation: false,
  noiseSuppression: false,
  autoGainControl: true,
}

/** Opus or AAC at 96 kbit/s: two minutes, the longest a sample runs, are about 1.4 MB. */
export const VOICE_SAMPLE_BITS_PER_SECOND = 96_000

export const VOICE_SAMPLE_RECORDER: BrowserRecorderOptions = {
  audio: VOICE_SAMPLE_AUDIO,
  audioBitsPerSecond: VOICE_SAMPLE_BITS_PER_SECOND,
  signal: true,
}

/** Ask for the microphone and put a voice sample's recorder on it. */
export const openVoiceSampleRecorder = (): Promise<RecorderDevice> =>
  openBrowserRecorder(VOICE_SAMPLE_RECORDER)
